import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import { path } from "~Tutor/TutorRoutes"
import { WithLoadingIndicator } from "~tailwindui/Basics"
import Table from "~tailwindui/Table/Table"

import LocalTime from "components/LocalTime"

export type PastSessionsProps = {
  studentId: string
}

const PastSessions: React.FC<PastSessionsProps> = ({ studentId }) => {
  const history = useHistory()
  const [page, setPage] = useState(1)

  const [result] = useQuery({
    query: pastSessionsQuery,
    variables: { studentId: studentId, page: page },
  })

  return (
    <div className="row">
      <WithLoadingIndicator
        result={result}
        error="An error occurred while loading the past sessions"
      >
        {({ data: { viewer } }) => (
          <Table
            title="Past Sessions"
            data={viewer.sessions}
            changePage={setPage}
            rowCallback={({ id }) => {
              history.push(path("sessionDetails", { id }))
            }}
            cols={[
              {
                header: "Subject",
                value: session => (
                  <span key={session.id} className="flex items-center">
                    {session.subject.name}
                  </span>
                ),
              },
              {
                header: "Date",
                value: session => (
                  <LocalTime
                    key={session.id}
                    format="ddd MMM D, YYYY"
                    timestamp={session.startsAt}
                  />
                ),
              },
              {
                header: "Time",
                value: session => (
                  <span key={session.id}>
                    <LocalTime omitDate timestamp={session.startsAt} />
                    &mdash;
                    <LocalTime omitDate timestamp={session.endsAt} />
                  </span>
                ),
              },
            ]}
          />
        )}
      </WithLoadingIndicator>
    </div>
  )
}

const pastSessionsQuery = gql`
  query PastSessions($studentId: ID!, $page: Int!) {
    viewer {
      sessions(
        filters: { studentId: $studentId, past: true, statusState: scheduled }
        page: $page
      ) {
        currentPage
        totalPages
        data {
          id
          startsAt
          endsAt
          subject {
            name
          }
        }
      }
    }
  }
`

export default PastSessions
